import { LocalDate } from "@js-joda/core";

export const STATE_COMPLIANCE_HIRE_DATE_FROM: LocalDate = LocalDate.parse("2022-02-01");
